import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryShowcase() {
  return (
    <section className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            内容分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            六大内容频道，总有一个适合你
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <span className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${cat.icon} text-primary-600 text-xl`} />
              </span>
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 text-center line-clamp-2">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}